<app-button icon="fa fa-envelope"
[disabled]="disabled" [label]="label" title="Envoyer une notification" (click)="sendReminder()">
</app-button>
